import $ from 'jquery';

class Point {

    x: number;
    y: number;

    constructor(xx:number,yy:number) {

        this.x = xx;
        this.y = yy;

    }

    static Sub(aa:Point,bb:Point):Point{
        var p=new Point(
            aa.x-bb.x,
            aa.y-bb.y
        );
        return p;
    }
    
    static Add(aa:Point,bb:Point):Point{
        var p=new Point(
            aa.x+bb.x,
            aa.y+bb.y
        );
        return p;
    }

    SetMagnitude(amp:number){

        let a = Math.sqrt(this.x*this.x + this.y*this.y);
        let r = Math.atan2(this.y,this.x);

        a=amp;

        this.x = a * Math.cos(r);
        this.y = a * Math.sin(r);
    }

    GetRotation():number{

        return Math.atan2(this.y,this.x);

    }

    Clone():Point{
        return new Point(this.x,this.y);
    }

}

export {Point};